module.exports = __webpack_public_path__ + "img/nb.f86a46fe.jpg";